module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.465d1aff.ttf";